import React from "react";
import classes from "./OrganizationCard.scss";
import { Button } from "@toddle-edu/ds-web";
import { DisableOutlined, LockOutlined } from "@toddle-edu/ds-icons";
import classNames from "classnames";

const OrganizationCard = props => {
  const {
    name,
    logo,
    linkedIdentityTitle,
    onSelectOrganization,
    userName,
    t,
    isGlobalHeaderPresent,
    shouldDisplayUsername,
    isAccessBlockedDueToMfa,
    canAccessOrg,
  } = props;

  const containerClasses = classNames({
    [classes.container]: true,
    [classes.containerV2]: !isGlobalHeaderPresent,
  });

  const identityTitleClasses = classNames({
    ["text-label-s"]: isGlobalHeaderPresent,
    [classes.identityTitle]: true,
  });

  const orgNameClasses = classNames({
    ["text-label"]: isGlobalHeaderPresent,
    [classes.orgName]: !isGlobalHeaderPresent,
  });

  const figureContainerClasses = classNames({
    [classes.figureContainer]: true,
    [classes.figureContainerV2]: !isGlobalHeaderPresent,
  });

  return (
    <div className={containerClasses}>
      <figure className={figureContainerClasses}>
        <img src={logo} className={classes.figure} alt={name} />
      </figure>
      <div>
        <div className={orgNameClasses}>{name}</div>
        {shouldDisplayUsername ? (
          <div className={identityTitleClasses}>{userName}</div>
        ) : null}
        <div className={identityTitleClasses}>
          {/** will be fixed once the identityTitle is fixed for cas also */}
          {linkedIdentityTitle === "Visitor - Authorization and evaluation"
            ? "Visitor"
            : linkedIdentityTitle}
        </div>
        {isAccessBlockedDueToMfa ? (
          <div className={classes.statusRow}>
            <DisableOutlined size="xx-small" />
            <span className={`text-label-s ${classes.textRed}`}>
              {t("common:access_blocked_title")}
            </span>
          </div>
        ) : !canAccessOrg ? (
          <div className={classes.statusRow}>
            <LockOutlined size="xx-small" />
            <span className={`text-label-s ${classes.textYellow}`}>
              {t("common:please_verify_2fa_to_access_organization")}
            </span>
          </div>
        ) : null}
      </div>

      <Button
        size={isGlobalHeaderPresent ? "small" : "large"}
        variant={"outlined-subtle"}
        onClick={onSelectOrganization}
        className={classes.selectButtonContainer}
        testId={`switchOrganization:org-list-item-${name}`}
        disabled={isAccessBlockedDueToMfa}
      >
        {isAccessBlockedDueToMfa
          ? t("common:blocked")
          : canAccessOrg
          ? t("common:select")
          : t("common:verify")}
      </Button>
    </div>
  );
};

export default OrganizationCard;
